
$.widget("bluaul.AutoCheckOverview", $.common.VisualBase, {
   /// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.AutoCheck.Overview <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 4.3.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 11.3.2022                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
    details: { acid: -1, bsaid: -1, blid: -1, dataType: -1, day: "" }, //used to load data for the popup logs
    vcV: new vcVisual(),
    _create: function () {
        var me = this;
        try {

            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 329;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //initiates the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {

            me.showMessage("", false);

            //we init the edit dialog
            me._initEditDialog(0.9, 0.9, "auto-check-overview");
            me._addEditForm();
         
            if (me.specific.showSingleProject =="true") {
                me.fnd("#div-col-left").hide();
                me.fnd("#div-col-right").css("width", "100%");
            } else {
          
                me.fnd("#div-col-right").width(parseInt(me.container.width - me.fnd("#div-col-left").width() - 23));
            }
            me.fnd("#div-list").height(parseInt(me.container.height - 99));
            me.fnd("#div-sub-list").height(me.fnd("#div-list").height());

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            //init the filters
            me.fnd("#div-filter").vcFilter({ callback: function () { me._filterList(); } });
            me.fnd("#div-sub-filter").vcFilter({ callback: function () { me._filterSubList(); } });

            //me.fnd("#div-list").off("click", ".open").on("click", ".open",
            //    function (e) { me._openDataCenter($(e.target)); });
            //add the checkbox click handler
            me.fnd("#div-sub-list").off("change", ".chk").on("change", ".chk",
                function (e) { me._setSeen($(e.target)); e.stopPropagation() });
            //show signals for the selected project
            me.fnd("#div-list").off("click", ".vc-list-item").on("click", ".vc-list-item",
                function (e) { me._fetchSubList($(e.target)); });

            //open popup for the selected signals
            me.fnd("#div-sub-list").off("click", ".vc-list-item").on("click", ".vc-list-item",
                function (e) { me._fetchLogs($(e.target)); });

            //open popup for the selected signals
            me.fnd("#div-sub-list").off("click", ".signal-info-popup").on("click", ".signal-info-popup",
                function (e) {

                    me.vcV.showDsEdit2Dialog({ LoggerId: parseInt($(e.target).data("blid")), bsaid: parseInt($(e.target).data("bsaid")), day: moment().format('DD.MM.YYYY') });
                    //me.vcV.showSignalAnalogSummaryDialog(parseInt($(e.target).data("bsaid")));
                    e.stopPropagation()
                });

            //me.vcVisual.showSignalAnalogSummaryDialog(bsaid);



            //get all projects
            me._fetch();

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },

    _addEditForm: function () {
        /// <summary>
        /// We init everything we need for the popup form
        /// </summary>
        var me = this;
        var w, h;
        try {

            //we get some height and width
            w = me.editDialog.width - 27;
            h = me.editDialog.height - 100;
            var div = $("<div>").attr("id", "div-logs");
            h -= 5;   //subtract the header
            div.append($("<div>").attr("id", "div-logs-list").height(h).addClass("vc-list vc-list-border"));
            div.append($("<div>").attr("id", "div-logs-chart").height(h));
            div.width(w).height(h);

            me.editDialog.html(div);

            //we init click handler for the logs list
            div.off("click", "#div-logs-list .vc-list-item").on("click", "#div-logs-list .vc-list-item", function (e) {
                if ($(e.target).hasClass("vc-list-item")) {
                    me.details.day = $(e.target).data("timestamp");
                } else {

                    me.details.day = $(e.target).parents(".vc-list-item").data("timestamp");
                }
                me._showChart();
            });


        } catch (e) {
            me.writeError('_addEditForm', e);
            return false;
        }
        return true;
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        try {

            me.fnd("#div-list").html(me.getLoadingIcon());
           
            me.getData({ typeId: 1 }, function (result) {

                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                if (result.rows == null) {
                    me.fnd("#div-list").html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                    return true;
                }
             
                me._generateList(result);
                if (me.specific.showSingleProject == "true") {
            
                     me._fetchSubList( me.fnd("#div-list .vc-list-item:first"));
                }
                return true;

            });

        } catch (e) { me.writeError('fetch', e); return false; }
        return true;
    },

    _generateList: function (data) {
        /// <summary>
        /// This function generates a list of projects  <br/>
        /// </summary>
        var me = this;
        var item;
        var sTmp;
        try {
            if (me.error) { return false; }

            var list = me.fnd("#div-list").html("");

            for (var i = 0; i < data.rows.length; i++) {
                item = $("<div>").addClass("vc-list-item projects").data("blid", data.rows[i].id);
                //if there is at least one rule which is active/invalid - we show an invalid icon
                if (data.rows[i].active > 0) {
                    item.addClass("invalid").append(me.specific.resources.iconInvalid + " ");
      
                }
                sTmp = data.rows[i].name + " (" + data.rows[i].entries + "/";
                if (data.rows[i].active > 0) {
                    sTmp += "<span class='icon-color-error'>" + data.rows[i].active + "</span>";
                } else {
                    sTmp += "<span>" + data.rows[i].active + "</span>";
                }
                sTmp += ")";
                list.append(item.append(sTmp));
            }

            me._filterList();

            return true;
        } catch (ex) {
            me.writeError('_generateList', ex);
            return false;
        }

    },

    _fetchSubList: function (obj) {
        /// <summary>
        /// This function fetches existing rule entries for one given project
        /// </summary>
        var me = this;
        try {



            me.fnd("#div-list .vc-list-item").removeClass("selected");
            var blid;
            if (obj.hasClass("vc-list-item")) {
                blid = parseInt(obj.data("blid"));
                obj.addClass("selected");
            } else {
                blid = parseInt(obj.parents(".vc-list-item").data("blid"));
                obj.parents(".vc-list-item").addClass("selected");
            }

            me.fnd("#div-sub-list").html(me.getLoadingIcon());

            me.getData({ typeId: 2, logicTypeId: me.logicTypeId, Id: blid }, function (result) {

                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                if (result.rows == null) {
                    me.fnd("#div-sub-list").html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                    return true;
                }

                return me._generateSubList(result);

            });

        } catch (e) { me.writeError('_fetchSubList', e); return false; }
        return true;
    },

    _generateSubList: function (data) {
        /// <summary>
        /// This function generates a list with rules for a single project
        /// </summary>
        var me = this;
        var sTmp;
        try {

            var list = me.fnd("#div-sub-list").html("");

            for (var i = 0; i < data.rows.length; i++) {
                    item = $("<div>").addClass("vc-list-item entry").data("details", { acid: data.rows[i].id, bsaid: data.rows[i].bsaid, blid: data.rows[i].blid, dataType: data.rows[i].logicdatatype });
               
                if (data.rows[i].type == 1) {
                    switch (data.rows[i].fullState) {
                        case -1:
                            sTmp = "<span>new</span>";
                            break;
                        case 0:
                            sTmp = "<span>OK</span>";
                            break;
                        case 1:
                            sTmp = "<span class='icon-color-error state-on' >ON</span>";
                            break;
                        case 11: //we ignore the active state as the signal has wrong plaus or datacenter manage type
                            sTmp = "n.a.";//"<span class='state-ignored'>ON</span>";
                            break;
                        default:
                    }
                } else {
                    sTmp = "-";
                }
                    item.append($("<div>").addClass("vc-list-col vc-list-col-element w5").html(sTmp));
                item.append($("<div>").addClass("vc-list-col vc-list-col-element w10").html(moment(data.rows[i].last_modified, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm:ss')));
                item.append($("<div>").addClass("vc-list-col vc-list-col-element w25").html(data.rows[i].name + " [" + data.rows[i].dims + "]" + "<i data-type='SIGNALINFO' data-bsaid='" + data.rows[i].bsaid + "' data-blid='" + data.rows[i].blid + "' class='vc-list-icon signal-info-popup fa fa-laptop-medical color-font-secondary'></i>" ));
                item.append($("<div>").addClass("vc-list-col vc-list-col-element w40").html(data.rows[i].logicName + " (" + data.rows[i].interval + "  " + data.rows[i].intervalType + ") - " + data.rows[i].report));
                sTmp = "";
                if (data.rows[i].commit) {
                    chk = $("<input>").prop("type", "checkbox").addClass("chk").data("id", data.rows[i].id).prop("checked", data.rows[i].seen);
                    sTmp = data.rows[i].seenInfo;

                } else {
                    chk = $("<div>").html("<br/>");
                }
                if (sTmp == ", ") sTmp = "<br/>";
                item.append($("<div>").addClass("vc-list-col vc-list-col-element w5").html(chk));
                item.append($("<div>").addClass("vc-list-col vc-list-col-element w15").css("font-size", "smaller").html(sTmp));
                    list.append(item);
                }

                 me._filterSubList();

            return true;

        } catch (e) { me.writeError('_generateSubList', e); return false; }
        return true;
    },

    _fetchLogs: function (obj) {
        /// <summary>
        /// This function fetches logs for one single rule entry
        /// </summary>
        var me = this;
        try {

            if (obj.hasClass("chk")) { return true;};


            me.fnd("#div-sub-list .vc-list-item").removeClass("selected");
            var acid;
            if (obj.hasClass("vc-list-item")) {
                me.details = obj.data("details");
                obj.addClass("selected");
            } else {
                me.details = obj.parents(".vc-list-item").data("details");
                obj.parents(".vc-list-item").addClass("selected");
            }
            me.editDialog.find("#div-logs-list").html(acid);
            me.editDialog.find("#div-logs-chart").html(me.bsaid);
            me.editDialog.dialog("open");
           
            me.getData({ typeId: 3, Id: me.details.acid }, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                //first we show the chart with the current date
                me.details.day = getCurrentTimestamp();
                me._showChart();
                return me._generateLogsList(result);

            });

        } catch (e) { me.writeError('_fetchLogs', e); return false; }
        return true;
    },

    _generateLogsList: function (data) {
        /// <summary>
        /// This function generates a list with logs for one single rule entry
        /// </summary>
        var me = this;
        var sTmp;
        try {
            
            if (data.rows == null) {
                me.editDialog.find("#div-logs-list").html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return true;
            }
            if (data.rows[0].log == null) {
                me.editDialog.find("#div-logs-list").html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return true;
            }

            var wrapper = me.editDialog.find("#div-logs-list").html("");
            var list = $("<div>").addClass("vc-list-table selectable-list");
            var logs = JSON.parse(data.rows[0].log);
            if (logs == null) {
                me.editDialog.find("#div-logs-list").html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return true;
            }
            for (var i = logs.length-1; i >= 0; i--) {
                item = $("<div>").addClass("vc-list-item entry").data("bsaid", logs[i].bsaid).data("dataType", logs[i].LogicDataType).data("timestamp", logs[i].Timestamp);
                //we have to do some chars clean up
                sTmp = logs[i].Text.replaceAll(",;", "<br/>");
                sTmp = sTmp.replaceAll(", ;", "<hr/>");
                
                sTmp = "<b>" + logs[i].Timestamp.replaceAll("'", "") + "</b><br/>" + sTmp;
                item.append($("<div>").addClass("vc-list-col").html(sTmp));

                list.append(item);
            }
           
            wrapper.html(list);
            wrapper.find(".vc-list-item:even").addClass("alt");
         
            return true;

        } catch (e) { me.writeError('_generateLogsList', e); return false; }
        return true;
    },

    _showChart: function () {
        /// <summary>
        /// decides which chart should get shown and opens it <br/>
        /// </summary>     
        var me = this;
        var signalParam = { 'series': [] };
      
        try {
            if (me.error) { return false; }


            me.container = me.getRandomIDContainerObj("div-logs-chart-", true);
            var chart = me.editDialog.find("#div-logs-chart");
            chart.html(me.container.obj);
            me.container.obj.width(parseInt(chart.width()));
            me.container.obj.height(parseInt(chart.height()));
            me.container.obj.html(me.getLoadingIcon());

            me.details.day = moment(me.details.day, "DD.MM.YYYY").format("DD.MM.YYYY");
        
           
            signalParam.series.push({ 'bsaid': [me.details.bsaid], 'rule': '[bsaid=' + me.details.bsaid + ']', 'ruleType': 1 });

            var param = {'loggerID': me.details.blid, 'ShowInvalidValues': true, 'ShowPlotLines': true, 'datatype': 1, 'startDate': me.details.day, 'endDate': me.details.day, 'NoZoom': false,
                'dateUserDef': true, 'ShowEmptyChart': true, 'ShowExportIcons': false, 'ShowUnsmoothedValues': true, 'HideNotAllowedIntervals': false, 'UseSimpleBottomLegend': true, 'UseWidgetHeaderDate': true,
                'GetSingleValuesAsConsumption':true            };
            var visual;
            if (me.details.dataType == 1) {
                visual = 'VISUAL_RAMP_SINGLE';
            } else {
                param.interval = 11;
                visual = 'VISUAL_RAMP_HR';
            }
       
           me.vcV.setShowFullscreen(false);
            me.vcV.setShowHeaderMenu(false);
            me.vcV.addVisualByName('div-logs-chart-', visual, me.container.random, me.details.day, parseInt(me.editDialog.find("#div-logs-chart").height()), parseInt(me.editDialog.find("#div-logs-chart").width()), JSON.stringify(param), JSON.stringify(signalParam), 1);


            return true;
        } catch (ex) { me.writeError('showChart', ex); return false; }
    },

    _filter: function (col, prefix) {
        /// <summary>
        /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }
          
            //hide all
            me.fnd(prefix + " .vc-list-item").removeClass("found").data("counter", 0).hide();

            //we add the 'found' class to all items we want to filter based on the vcfilter tags
            me.setTagFilter(col + " .vc-filter", prefix + " .vc-list-item", "found");
        
            me.fnd(prefix + " .vc-list-item.found").show();
            me.fnd(prefix + " .vc-list-item").removeClass("alt");
            me.fnd(prefix + " .vc-list-item.found:even").addClass("alt");


            return true;
        } catch (ex) {
            me.writeError('filter', ex);
            return false;
        }

    },

    _filterList: function () {
        /// <summary>
        /// This function filters the project list  <br/>
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }
            return me._filter("#div-col-left", "#div-list");
        } catch (ex) {
            me.writeError('_filterList', ex);
            return false;
        }

    },

    _filterSubList: function () {
        /// <summary>
        /// This function filters the signal list <br/>
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }
           
            return me._filter("#div-col-right", "#div-sub-list");
        } catch (ex) {
            me.writeError('_filterSubList', ex);
            return false;
        }

    },

    _setSeen: function (obj) {
        /// <summary>
        /// This function saves the new seen setting
        /// </summary>
        var me = this;
        try {
          
            me.updateData({ typeId: 1, id: parseInt(obj.data("id")), seen: obj.prop("checked") }, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                me._fetchSubList(me.fnd("#div-list .selected"));
                return true;
            });

        } catch (e) { me.writeError('setSeen', e); return false; }
        return true;
    },

    _openDataCenter: function (obj) {
        /// <summary>
        /// This function saves everything
        /// </summary>
        var me = this;
        try {
          
            _VCMQ.produce($(me.visual), 1, 'MANUAL_EDIT_DAY', { 'day': obj.parents(".vc-list-item").data("last_modified"), loggerid: parseInt(obj.parents(".vc-list-item").data("blid")) });

        } catch (e) { me.writeError('openDataCenter', e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-col-left, #div-col-right").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});

